export const PoseCheck = ({ pose, rounds = [], sport = "" }) => {
  const striking = /box|mma|martial|kick|muay|taekwondo|karate/i.test(sport);
  const sides = Object.entries(pose?.sides || {});
  if (!sides.length) return null;
  const thrown = rounds.reduce((n, r) => n + (r.totals?.thrown || 0), 0);
  const strikes = sides.reduce((n, [, v]) => n + (v.strike_like_moves || 0), 0);
  return (
    <section className="px-4 sm:px-6 py-4 border-t border-border" data-testid="film-pose">
      <h3 className="font-heading font-bold">Pose check</h3>
      <p className="text-xs text-muted-foreground mb-3">{`${pose.model} · ${Math.round(pose.seconds_analysed / 60)} min analysed · ${pose.people_per_frame} people per frame on average`}</p>
      <div className="grid sm:grid-cols-2 gap-3">
        {sides.map(([side, v]) => (
          <div key={side} className="border border-border p-3" data-testid={`film-pose-${side}`}>
            <p className="text-xs uppercase tracking-widest text-muted-foreground">{`${side} of frame`}</p>
            <dl className="grid grid-cols-3 gap-2 mt-2 text-sm">
              <div><dt className="text-[10px] text-muted-foreground">Work rate</dt><dd className="font-heading text-xl font-black tabular-nums">{v.work_rate}</dd></div>
              <div><dt className="text-[10px] text-muted-foreground">Burst time</dt><dd className="font-heading text-xl font-black tabular-nums">{`${v.burst_share_pct}%`}</dd></div>
              {striking && <div><dt className="text-[10px] text-muted-foreground">Strike-like moves</dt><dd className="font-heading text-xl font-black tabular-nums">{v.strike_like_moves}</dd></div>}
            </dl>
          </div>
        ))}
      </div>
      {striking && thrown > 0 && <p className="text-xs mt-3" data-testid="film-pose-agreement">{`Video AI counted ${thrown} strikes thrown; the pose model saw ${strikes} fast arm extensions. ${Math.abs(thrown - strikes) <= Math.max(thrown, strikes) * 0.25 ? "The two broadly agree." : "They disagree by more than 25%. Review the round counts before saving."}`}</p>}
      <p className="text-[11px] text-muted-foreground mt-2">{pose.note}</p>
    </section>
  );
};
